import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NOTIFICACIONES } from '@env';

@Injectable()
export class NotificacionesProvider {

  constructor(public http: HttpClient) {
  }

  getNotifications(area, jugador, pagina): Promise<any> {
    return this.http.get( `${NOTIFICACIONES.GET}${area}/${jugador}/${pagina}`).toPromise();
  }

}



// WEBPACK FOOTER //
// ./src/providers/notificaciones/notificaciones.ts